export default __webpack_public_path__ + "static/media/Step 2.92c435b9.svg";